var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 8,14.502 10.13,14.502 12.35,14.502  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 19.19,
    y1: 14.502,
    x2: 16.58,
    y2: 14.502
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.77,
    y1: 14.502,
    x2: 0.81,
    y2: 14.502
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 7.997,16.196 3.768,17.538 3.768,11.464 7.997,12.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 12.347,12.807 16.576,11.464 16.576,17.538 12.347,16.208  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.13,
    y1: 14.501,
    x2: 10.13,
    y2: 9.456
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M3.77,8.872c0-3.54,2.87-6.41,6.4-6.41c3.54,0,6.41,2.87,6.41,6.41"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16.58,
    y1: 8.872,
    x2: 3.77,
    y2: 8.872
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPid);
export default __webpack_public_path__ + "static/media/light-pid.decd920a5dd5362ea144ac2bcfa60ca7.svg";
export { ForwardRef as ReactComponent };